import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/Poshmark-My-Inventory-Report';

export default function Example() {
  return (
    <>
      <Head>
        <title>Poshmark My Inventory Report 101 </title>
        <meta
          name='description'
          content="Poshmark Inventory is a useful tool for Poshmark sellers. The report provides insights into the products performing well, items with high engagement, and more. It's easy to use and gives you everything you need to make smart decisions about your Poshmark business. "
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/Poshmark-My-Inventory-Report' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/Poshmark-My-Inventory-Report' />
        <meta property='og:title' content='Poshmark My Inventory Report 101 ' />
        <meta
          property='og:description'
          content="Poshmark Inventory is a useful tool for Poshmark sellers. The report provides insights into the products performing well, items with high engagement, and more. It's easy to use and gives you everything you need to make smart decisions about your Poshmark business. "
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
